import {Action} from 'redux'
import {SubsidiaryPageModel} from '../Model/SubsidiaryPageModel'
import {actionTypes} from './constants'

export interface ActionWithPayload<T> extends Action {
  payload?: T
}

const initialSubsidiaryPageState: ISubsidiaryPageState = {
  data: {
    subsidiaryPage: [],
    meta: [],
  },
  sortSubsidiaryPageData: [],
  subsidiaryPageList: {subsidiaryPage: []},
  deleteSuccess: false,
  enableSuccess: false,
  disableSuccess: false,
  singleEnableSuccess: false,
  singleDisableSuccess: false,
  loading: false,
  success: false,
}

export interface ISubsidiaryPageState {
  data?: {
    subsidiaryPage?: SubsidiaryPageModel[]
    meta?: {[key: string]: string | number}[]
  }
  sortSubsidiaryPageData?: ISubsidiaryPageState[]
  subsidiaryPageList?: {subsidiaryPage: SubsidiaryPageModel[]}
  deleteSuccess?: boolean
  enableSuccess?: boolean
  disableSuccess?: boolean
  singleEnableSuccess?: boolean
  singleDisableSuccess?: boolean
  loading?: boolean
  success?: boolean
}

export const reducer = (
  state: ISubsidiaryPageState = initialSubsidiaryPageState,
  action: ActionWithPayload<ISubsidiaryPageState>
) => {
  switch (action.type) {
    case actionTypes.GET_ALL_SUBSIDIARY_PAGE_START: {
      return {...state, loading: true}
    }

    case actionTypes.GET_ALL_SUBSIDIARY_PAGE_SUCCESS: {
      return {
        ...state,
        data: action.payload,
        subsidiaryPageList: action.payload,
        loading: false,
      }
    }

    case actionTypes.GET_ALL_SUBSIDIARY_PAGE_FINISH: {
      const error = action.payload
      return {...state, error, loading: false}
    }

    //GET SubsidiaryPage DATA
    case actionTypes.GET_SUBSIDIARY_PAGE_START: {
      return {...state, loading: true}
    }

    case actionTypes.GET_SUBSIDIARY_PAGE_SUCCESS: {
      return {...state, data: action.payload, loading: false}
    }

    case actionTypes.GET_SUBSIDIARY_PAGE_FINISH: {
      const error = action.payload
      return {...state, error, loading: false}
    }

    //Add SubsidiaryPage
    case actionTypes.ADD_SUBSIDIARY_PAGE_START: {
      return {...state, loading: true}
    }

    case actionTypes.ADD_SUBSIDIARY_PAGE_SUCCESS: {
      return {
        ...state,
        data: action?.payload?.data,
        success: true,
        loading: false,
      }
    }

    case actionTypes.ADD_SUBSIDIARY_PAGE_FINISH: {
      const error = action.payload
      return {...state, error, loading: false}
    }

    case actionTypes.RESET_SUBSIDIARY_PAGE: {
      return {
        ...state,
        data: [],
        success: false,
      }
    }

    //Update SubsidiaryPage
    case actionTypes.UPDATE_SUBSIDIARY_PAGE_START: {
      return {...state, loading: true}
    }

    case actionTypes.UPDATE_SUBSIDIARY_PAGE_SUCCESS: {
      return {
        ...state,
        data: action?.payload?.data,
        success: true,
        loading: false,
      }
    }

    case actionTypes.UPDATE_SUBSIDIARY_PAGE_FINISH: {
      const error = action.payload
      return {...state, error, loading: false}
    }

    //Delete
    case actionTypes.DELETE_SUBSIDIARY_PAGE_START: {
      return {...state, loading: true}
    }

    case actionTypes.DELETE_SUBSIDIARY_PAGE_SUCCESS: {
      return {
        ...state,
        deleteSuccess: true,
        loading: false,
      }
    }

    case actionTypes.DELETE_SUBSIDIARY_PAGE_FINISH: {
      return {
        ...state,
        loading: false,
        deleteSuccess: false,
      }
    }

    //Enable
    case actionTypes.ENABLE_SUBSIDIARY_PAGE_REQUEST: {
      return {...state, loading: true}
    }

    case actionTypes.ENABLE_SUBSIDIARY_PAGE_SUCCESS: {
      return {
        ...state,
        enableSuccess: true,
        loading: false,
      }
    }

    case actionTypes.ENABLE_SUBSIDIARY_PAGE_FINISH: {
      return {
        ...state,
        loading: false,
        enableSuccess: false,
      }
    }

    //disable
    case actionTypes.DISABLE_SUBSIDIARY_PAGE_REQUEST: {
      return {...state, loading: true}
    }

    case actionTypes.DISABLE_SUBSIDIARY_PAGE_SUCCESS: {
      return {
        ...state,
        disableSuccess: true,
        loading: false,
      }
    }

    case actionTypes.DISABLE_SUBSIDIARY_PAGE_FINISH: {
      return {
        ...state,
        loading: false,
        disableSuccess: false,
      }
    }
    //Enable
    case actionTypes.SINGLE_ENABLE_SUBSIDIARY_PAGE_REQUEST: {
      return {...state, toggleLoading: true}
    }

    case actionTypes.SINGLE_ENABLE_SUBSIDIARY_PAGE_SUCCESS: {
      const changedData: any = action.payload?.data?.subsidiaryPage
      let newData = state?.data?.subsidiaryPage?.map((data) => {
        if (data?.id === changedData[0]?.id) {
          return {
            ...data,
            status: !data?.status,
          }
        } else {
          return data
        }
      })
      return {
        ...state,
        data: {...state, meta: state?.data?.meta, subsidiaryPage: newData},
        singleEnableSuccess: true,
        toggleLoading: false,
      }
    }

    case actionTypes.SINGLE_ENABLE_SUBSIDIARY_PAGE_FINISH: {
      return {
        ...state,
        singleEnableSuccess: false,
        toggleLoading: false,
      }
    }

    //Disable
    case actionTypes.SINGLE_DISABLE_SUBSIDIARY_PAGE_REQUEST: {
      return {...state, toggleLoading: true}
    }

    case actionTypes.SINGLE_DISABLE_SUBSIDIARY_PAGE_SUCCESS: {
      const changedData: any = action.payload?.data?.subsidiaryPage
      let newData = state?.data?.subsidiaryPage?.map((data) => {
        if (data?.id === changedData[0]?.id) {
          return {
            ...data,
            status: !data?.status,
          }
        } else {
          return data
        }
      })

      return {
        ...state,
        data: {...state, meta: state?.data?.meta, subsidiaryPage: newData},
        singleDisableSuccess: true,
        toggleLoading: false,
      }
    }

    case actionTypes.SINGLE_DISABLE_SUBSIDIARY_PAGE_FINISH: {
      return {
        ...state,
        singleDisableSuccess: false,
        toggleLoading: false,
      }
    }

    // sort
    case actionTypes.SORT_SUBSIDIARY_PAGE_START: {
      return {...state, loading: true}
    }

    case actionTypes.SORT_SUBSIDIARY_PAGE_SUCCESS: {
      return {
        ...state,
        sortSubsidiaryPageData: action?.payload,
        success: true,
        loading: false,
      }
    }

    case actionTypes.SORT_SUBSIDIARY_PAGE_FINISH: {
      return {
        ...state,
        loading: false,
        success: false,
      }
    }

    case actionTypes.SORT_SUBSIDIARY_PAGE_RESET: {
      return {
        ...state,
        loading: false,
        success: false,
        sortSubsidiaryPageData: [],
      }
    }

    default:
      return state
  }
}
